import messages from 'GenericTexting/ducks/message';
import clients from 'GenericTexting/ducks/client';
import clientMessages from 'GenericTexting/ducks/clientMessage';
import dispositions from 'GenericTexting/ducks/disposition';
import keywords from 'GenericTexting/ducks/keyword';

export default {
  messages,
  clients,
  clientMessages,
  dispositions,
  keywords,
};
